import styled from 'styled-components';
import { brand, tones } from '../../../styles/brand';

export const Wrapper = styled.span<{ $color: string }>`
  position: relative;
  display: inline-grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  flex: none;
  color: ${({ $color }) => $color};
  font-family: 'RedHatDisplay-ExtraBold';
  font-variant-numeric: tabular-nums;

  > svg {
    width: 1.75rem;
    height: 1.75rem;
  }
`;

/** Número da posição sobre a medalha, no canto inferior direito. */
export const Rank = styled.span<{ $color: string }>`
  font-variant-numeric: tabular-nums;
  position: absolute;
  right: -0.15rem;
  bottom: -0.1rem;
  min-width: 0.95rem;
  height: 0.95rem;
  padding: 0 0.2rem;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-size: 0.6rem;
  line-height: 1;
  color: ${brand.white};
  background: ${({ $color }) => $color};
  box-shadow: 0 0 0 1.5px ${brand.white};
`;

export const Plain = styled.span`
  display: inline-grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.9rem;
  font-variant-numeric: tabular-nums;
  color: ${tones.gray.text};
`;
